import { ChangeEvent, FormEvent } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import dayjs from 'dayjs';

import useAmplitudeContext from '@/hooks/useAmplitudeContext';
import {
    eventsLoad,
    selectEventCardsSortedByDate,
    selectEventCardsSortedByScore,
    selectEventsSearchIds,
} from '@/store/calendar-events';
import { eventsSearchReset } from '@/store/calendar-events/calendar-events.actions';
import { selectEventsLoading } from '@/store/calendar-events/calendar-events.selectors';
import { searchSortByScoreSet, searchStringSet, selectSearchArgs } from '@/store/calendar-filters';
import { searchRangeSet } from '@/store/calendar-filters/calendar-filters.actions';
import { selectRulerDateRange } from '@/store/calendar-navigation';
import { amplitudeEvents } from '@/utils/constants';

export default function useEventCards() {
    const { trackAmplitudeEvent } = useAmplitudeContext();

    const searchArgs = useSelector(selectSearchArgs);
    const eventsSortedByDates = useSelector(selectEventCardsSortedByDate);
    const eventsSortedByScore = useSelector(selectEventCardsSortedByScore);
    const loading = useSelector(selectEventsLoading);

    const events = searchArgs.sortByScore ? eventsSortedByScore : eventsSortedByDates;

    const selectedDays = useSelector(selectRulerDateRange);
    const startDate = dayjs(selectedDays[0]).startOf('day');
    const endDate = dayjs(selectedDays[1]).endOf('day');

    const dispatch = useDispatch();

    const withSearch = useSelector(selectEventsSearchIds).length > 0;

    const notFoundString: 'day' | 'range' = startDate.isSame(endDate) ? 'day' : 'range';
    const notFoundContext = events.length === 0 ? notFoundString : null;

    const toggleSearchRangeOn = () => {
        dispatch(searchRangeSet(true));
    };
    const toggleSearchRangeOff = () => {
        dispatch(searchRangeSet(false));
    };

    const sortByScore = () => {
        dispatch(searchSortByScoreSet(true));
    };

    const sortByDate = () => {
        dispatch(searchSortByScoreSet(false));
    };

    const onSearchChange = (e: ChangeEvent<HTMLInputElement>) => {
        dispatch(searchStringSet(e.target.value));
        e.target.value.length === 0 && onSearchClear();
    };

    const onSearchSubmit = (e?: FormEvent) => {
        e && e.preventDefault();
        dispatch(eventsLoad());
        trackAmplitudeEvent(amplitudeEvents.SEARCH_FORM_SUBMIT, { value: searchArgs.searchString });
    };

    const onSearchClear = () => {
        dispatch(eventsSearchReset());
        dispatch(searchStringSet(''));
    };

    //todo scroll button handler

    // const [eventSlice, setEventSlice] = useState(1);
    // useEffect(() => {
    //     const handleLoadMore = () => {
    //         if (window.scrollY + window.innerHeight >= document.body.clientHeight * 0.45) {
    //             setEventSlice((eventSlice + 1) * 3);
    //         }
    //     };
    //     window.addEventListener('scroll', handleLoadMore);
    //
    //     return () => window.removeEventListener('scroll', handleLoadMore);
    // }, [eventSlice]);
    //
    // useEffect(() => {
    //     const handleLoadMore = () => {
    //         if (window.scrollY + window.innerHeight >= document.body.clientHeight * 0.45) {
    //             setEventSlice((eventSlice + 1) * 3);
    //         }
    //     };
    //     if (eventSlice >= events.length) {
    //         window.removeEventListener('scroll', handleLoadMore);
    //     }
    // }, [eventSlice, events.length]);

    return {
        searchArgs: searchArgs,
        notFoundContext: notFoundContext,
        events: events,
        withSearch: withSearch,
        loading: loading,
        toggleSearchRangeOff: toggleSearchRangeOff,
        toggleSearchRangeOn: toggleSearchRangeOn,
        onSearchChange: onSearchChange,
        onSearchClear: onSearchClear,
        sortByScore: sortByScore,
        sortByDate: sortByDate,
        onSearchSubmit: onSearchSubmit,
    };
}
